import { render } from "./LogoAuth.vue?vue&type=template&id=6e510e96"
import script from "./LogoAuth.vue?vue&type=script&lang=js"
export * from "./LogoAuth.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Apps\\AppBase\\app-base-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__